import { ReactNode } from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import { BouSpacingLevel, fluidSpacing } from '../layout/bou-spacing';
import { fluidSpaceLg } from '../utilities/fluid/fluid';
import {
  CloseButton,
  // InnerContent,
  Main,
  stylesOverride,
  Title,
  TitleBlock,
} from './styles-private';

interface Props {
  isOpen: boolean;
  modalName: string; // Required for screen readers
  title?: ReactNode;
  closeModal: () => void;
  style?: Modal.Styles;
  showOverflow?: boolean;
  noPadding?: boolean;
  children?: ReactNode;
}

export const StandaloneModal = (props: Props) => {
  const { isOpen, closeModal, modalName, title, style, showOverflow = false, noPadding } = props;

  const styleBase = style || stylesOverride;

  const showOverFlowStyles = {
    ...styleBase,
    content: {
      ...styleBase.content,
      overflow: 'visible',
    },
  };

  const stylesToUse = showOverflow ? showOverFlowStyles : styleBase;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel={modalName}
      style={stylesToUse}
      shouldCloseOnOverlayClick={true}
    >
      <>
        {props.title ? (
          <TitleBlock>
            <Title>{title}</Title>
            <CloseButton aria-label={`Close ${modalName} modal`} onClick={closeModal}>
              &times;
            </CloseButton>
          </TitleBlock>
        ) : (
          <NoTitleCloseButtonWrap>
            <CloseButton aria-label={`Close ${modalName} modal`} onClick={closeModal}>
              &times;
            </CloseButton>
          </NoTitleCloseButtonWrap>
        )}
        <Main showOverflow={showOverflow} noPadding={noPadding}>
          {isOpen && props.children}
        </Main>
      </>
    </Modal>
  );
};

const NoTitleCloseButtonWrap = styled(TitleBlock)`
  border: none;
  justify-content: flex-end;
  padding: 0;
  ${fluidSpacing('height', BouSpacingLevel.TINYISH)}
  ${fluidSpaceLg('padding-right', 30)}
  ${fluidSpaceLg('padding-top', 40)}
`;
